import React from 'react'
import { Button } from 'primereact/button'
import { Tag } from 'primereact/tag'

const activeTabStyle = {
  fontWeight: 700,
  borderBottom: '2px solid #1976d2',
  borderRadius: 0,
  color: '#1976d2',
} as React.CSSProperties

const Empty = ({ message = 'No tickets found.' }) => (
  <div style={{ textAlign: 'center', padding: '32px 0', color: '#aaa' }}>
    <i className="pi pi-inbox" style={{ fontSize: 36, marginBottom: 8 }}></i>
    <div style={{ marginTop: 6, fontSize: 14 }}>{message}</div>
  </div>
)

const TicketList = ({
                      tickets,
                      selectedTicket,
                      onSelectTicket,
                      ticketStatus,
                      setTicketStatus,
                      onCreateTicket,
                    }: {
  tickets: any[]
  selectedTicket: any
  onSelectTicket: (ticket: any) => void
  ticketStatus: string
  setTicketStatus: (status: string) => void
  onCreateTicket: () => void
}) => {

  return (
    <div style={{ width: 360, borderRight: '1px solid #eee', paddingRight: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
        <Button
          label="Open Tickets"
          className="p-button-text"
          style={
            ticketStatus === 'open' ? { ...activeTabStyle, marginRight: 8 } : { marginRight: 8 }
          }
          onClick={() => setTicketStatus('open')}
        />
        <Button
          label="Closed Tickets"
          className="p-button-text"
          style={ticketStatus === 'closed' ? activeTabStyle : {}}
          onClick={() => setTicketStatus('closed')}
        />
        <Button
          icon="pi pi-plus"
          className="p-button-rounded p-button-info p-ml-auto"
          onClick={onCreateTicket}
          style={{ marginLeft: 'auto' }}
        />
      </div>
      <div>
        {tickets.length === 0 ? (
          <Empty message={`No ${ticketStatus === 'open' ? 'open' : 'closed'} tickets.`} />
        ) : (
          tickets.map((ticket) => {
            const isClosed = ticketStatus === 'closed'
            const isSelected = selectedTicket?.id === ticket.id

            return (
              <div
                key={ticket.id}
                onClick={() => onSelectTicket(ticket)}
                style={{
                  background: isSelected ? '#e3f2fd' : '#fff',
                  borderRadius: 10,
                  padding: 10,
                  marginBottom: 10,
                  cursor: 'pointer',
                  border: isSelected ? '2px solid #1976d2' : '1px solid #eee',
                  boxShadow: isSelected ? '0 2px 8px #1976d220' : '0 1px 2px #0001',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  outline: isSelected ? 'none' : undefined,
                }}
                onMouseOver={(e) => (e.currentTarget.style.boxShadow = '0 2px 8px #1976d220')}
                onMouseOut={(e) =>
                  (e.currentTarget.style.boxShadow = isSelected
                    ? '0 2px 8px #1976d220'
                    : '0 1px 2px #0001')
                }
              >
                {isClosed ? (
                  <i
                    className="pi pi-times"
                    style={{ fontSize: 20, color: '#e53935', marginRight: 10 }}
                  ></i>
                ) : (
                  <i
                    className="pi pi-comments"
                    style={{ fontSize: 20, color: '#43a047', marginRight: 10 }}
                  ></i>
                )}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: 15,
                      marginBottom: 1,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 180,
                    }}
                  >
                    {ticket.title}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: '#888',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                    }}
                  >
                    <Tag
                      value={ticket.status}
                      severity={
                        ticket.status === 'Completed' || ticket.status === 'Resolved'
                          ? 'success'
                          : isClosed
                            ? 'danger'
                            : 'success'
                      }
                      style={{
                        marginRight: 6,
                        borderRadius: 6,
                        fontWeight: 600,
                        fontSize: 11,
                        padding: '1px 8px',
                      }}
                    />
                    <span style={{ color: '#1976d2', fontWeight: 500 }}>Dept:</span>{' '}
                    {ticket.departmentName || ticket.department?.name || '-'}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: '#888',
                    minWidth: 70,
                    textAlign: 'right',
                    fontWeight: 500,
                  }}
                >
                  {ticket.createdAt
                    ? (() => {
                      const d = new Date(ticket.createdAt)
                      const day = d.getDate().toString().padStart(2, '0')
                      const month = (d.getMonth() + 1).toString().padStart(2, '0')
                      const year = d.getFullYear()
                      const time = d.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                      })
                      return `${day}-${month}-${year} ${time}`
                    })()
                    : ''}
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

export default TicketList
